import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import { ArrowLeft } from 'lucide-react';

const PhotoGallery = () => {
  const navigate = useNavigate();

  const photos = [
    {
      src: "https://interfaces-cdn.zapier.com/8da60066-b07f-472b-a9c5-97e4120792e0/IMG_1846.JPG",
      alt: "Rodeo event photo 1",
      caption: "2024 Rodeo Championship"
    },
    {
      src: "https://interfaces-cdn.zapier.com/297811e8-e403-408a-904e-65f97d21f44d/IMG_9689.jpeg",
      alt: "Rodeo event photo 2",
      caption: "Bareback Riding Competition"
    },
    {
      src: "https://interfaces-cdn.zapier.com/87a20825-7033-4dc2-981d-6b7445b629a2/IMG_4805.jpeg",
      alt: "Rodeo event photo 3",
      caption: "Bull Riding Final"
    },
    {
      src: "https://interfaces-cdn.zapier.com/85d0a0a4-0800-4985-a18b-55c71e2bd8d6/IMG_96882.jpeg",
      alt: "Rodeo event photo 4",
      caption: "Opening Ceremony"
    },
    {
      src: "https://interfaces-cdn.zapier.com/4924eb15-2963-4e7b-9475-60c890282641/IMG_4804.jpeg",
      alt: "Rodeo event photo 5",
      caption: "Barrel Racing Competition"
    },
    {
      src: "https://interfaces-cdn.zapier.com/d75ca825-08f8-4c2b-b720-233dc382f4fd/IMG_2799EC961E3E1.jpeg",
      alt: "Rodeo event photo 6",
      caption: "Steer Wrestling"
    },
    {
      src: "https://interfaces-cdn.zapier.com/97ebce53-e75f-471a-8111-60636e06d2fc/IMG_BFE889E8050B1.jpeg",
      alt: "Rodeo event photo 7",
      caption: "Team Roping"
    },
    {
      src: "https://interfaces-cdn.zapier.com/8635962d-9eec-4f90-aac5-ae011ec69b61/horsepicture.jpg",
      alt: "Rodeo event photo 8",
      caption: "Rodeo Horse"
    }
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <div className="max-w-6xl mx-auto pb-16 pt-8">
      <div className="mb-8 flex items-center mt-6">
        <Button 
          variant="outline" 
          className="mr-4"
          onClick={() => navigate('/')}
          icon={<ArrowLeft size={18} />}
        >
          Back to Home
        </Button>
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-primary-900">
          Photo Gallery
        </h1>
      </div>
      
      <p className="text-gray-700 mb-8 max-w-3xl">
        Browse our collection of photos from previous rodeo events. These photos showcase the excitement, 
        skill, and tradition that make the Salina Independence Day Rodeo a beloved event year after year.
      </p>

      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
      >
        {photos.map((photo, index) => (
          <motion.div
            key={index}
            variants={item}
            className="rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
          >
            <div className="relative aspect-[4/3]">
              <img 
                src={photo.src} 
                alt={photo.alt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-3 bg-white">
              <p className="text-gray-700 text-center">{photo.caption}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default PhotoGallery;